<div class="container-fluid v2-active h-100">
    <div class="row h-100">
        <!-- Coluna Esquerda -->

        <div class="col-md-4 col-12 d-flex flex-column coluna coluna-esquerda">
            <div class="d-flex flex-column align-items-center justify-content-center h-100">
                <div class="div-form">
                    <div class="">
                        <img
                            [src]="
                                themeService.isDark()
                                    ? '../../../../assets/img/icone_amarelo.png'
                                    : '../../../../assets/icone/icone-preto.png'
                            "
                            width="100px"
                        />
                    </div>

                    <div class="py-3">
                        <p class="login-titulo my-3">
                            {{ 'auth.cadastro.title' | transloco }} <br />
                            {{ 'auth.cadastro.titleBrand' | transloco }}
                        </p>
                        <p class="login-subtitulo">
                            {{ 'auth.cadastro.subtitle' | transloco }}
                        </p>
                    </div>

                    <form class="form" [formGroup]="loginForm">
                        <div class="w-100 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'auth.cadastro.name' | transloco }}</mat-label>
                                <input
                                    type="text"
                                    matInput
                                    formControlName="nome"
                                    [placeholder]="'auth.cadastro.namePlaceholder' | transloco"
                                />
                            </mat-form-field>

                            @if (loginForm.get('nome')?.invalid && loginForm.get('nome')?.touched) {
                                <small class="text-danger">
                                    <mat-error>{{ 'auth.cadastro.nameRequired' | transloco }}</mat-error>
                                </small>
                            }
                        </div>

                        <div class="w-100 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'auth.cadastro.document' | transloco }}</mat-label>
                                <input
                                    type="text"
                                    matInput
                                    formControlName="documento"
                                    [placeholder]="'auth.cadastro.documentPlaceholder' | transloco"
                                />
                            </mat-form-field>
                            @if (loginForm.get('documento')?.invalid && loginForm.get('documento')?.touched) {
                                <small class="text-danger">
                                    <mat-error>{{ 'auth.cadastro.documentRequired' | transloco }}</mat-error>
                                </small>
                            }
                        </div>

                        <div class="w-100 mb-3">
                            <mat-form-field appearance="outline" class="w-100" subscriptSizing="fixed">
                                <mat-label>{{ 'auth.cadastro.whatsappLabel' | transloco }}</mat-label>
                                <input
                                    type="text"
                                    matInput
                                    formControlName="celular_cript"
                                    [placeholder]="
                                        (useDDI
                                            ? 'auth.cadastro.whatsappPlaceholderWithDDI'
                                            : 'auth.cadastro.whatsappPlaceholderNoDDI'
                                        ) | transloco
                                    "
                                />
                            </mat-form-field>

                            @if (getCelularErrorMessage(); as msg) {
                                <small class="text-danger">
                                    <mat-error>{{ msg }}</mat-error>
                                </small>
                            }
                        </div>

                        <div class="w-100 mb-3">
                            <mat-form-field appearance="outline" class="w-100" subscriptSizing="fixed">
                                <mat-label>{{ 'auth.form.email' | transloco }}</mat-label>
                                <input
                                    type="email"
                                    formControlName="email"
                                    matInput
                                    [placeholder]="'auth.form.emailPlaceholder' | transloco"
                                />
                            </mat-form-field>
                            @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
                                @if (loginForm.get('email')?.errors?.['required']) {
                                    <small class="text-danger">
                                        <mat-error>{{ 'auth.form.emailRequired' | transloco }}</mat-error>
                                    </small>
                                } @else if (loginForm.get('email')?.errors?.['email']) {
                                    <small class="text-danger">
                                        <mat-error>{{ 'auth.form.emailInvalid' | transloco }}</mat-error>
                                    </small>
                                }
                            }
                        </div>

                        <div class="w-100 mb-3">
                            <mat-form-field appearance="outline" class="w-100" subscriptSizing="fixed">
                                <mat-label>{{ 'auth.form.password' | transloco }}</mat-label>
                                <input
                                    [type]="showPassword ? 'text' : 'password'"
                                    matInput
                                    formControlName="senha"
                                    [placeholder]="'auth.form.passwordPlaceholder' | transloco"
                                />
                                <button
                                    matSuffix
                                    mat-icon-button
                                    [attr.aria-label]="'auth.form.password' | transloco"
                                    (mousedown)="chageShowPassword()"
                                >
                                    <mat-icon>{{ iconName }}</mat-icon>
                                </button>
                            </mat-form-field>
                            @if (senha?.invalid && senha?.touched) {
                                @if (senha?.errors?.['passwordInvalid']; as errKey) {
                                    <small class="text-danger">
                                        <mat-error>{{ errKey | transloco }}</mat-error>
                                    </small>
                                }
                            }
                        </div>

                        <div class="w-100 pb-3">
                            <button
                                mat-stroked-button
                                [disabled]="loginForm.invalid"
                                class="w-100"
                                type="submit"
                                (click)="onSubmit()"
                            >
                                {{ 'auth.cadastro.submit' | transloco }}
                            </button>
                        </div>

                        <div class="div-esqueci-senha">
                            <span>
                                <a class="link" [href]="hubLoginUrl">
                                    {{ 'auth.cadastro.alreadyHaveAccount' | transloco }}
                                    <b>{{ 'auth.cadastro.signIn' | transloco }}</b>
                                </a>
                            </span>
                        </div>
                    </form>
                </div>

                <div class="d-flex justify-content-end align-items-center gap-2 my-2">
                    <app-theme-switcher [showTooltip]="false"></app-theme-switcher>
                    <app-language-toggle></app-language-toggle>
                </div>
            </div>
        </div>

        <div
            class="col-md-8 d-none d-md-flex flex-column justify-content-center align-items-center coluna coluna-direita"
        >
            <app-auth-right-column></app-auth-right-column>
        </div>
    </div>
</div>
